export default __webpack_public_path__ + "static/media/default-profile-thumb.aa5098e4.svg";